<template>
  <div>

    <v-sheet class="mx-sm-8 pa-4 mb-6 rounded-lg" v-if="this.registrations.length">

      <h2>
        <v-icon color="warning">mdi-cloud-alert</v-icon>
        Lokaal opgeslagen registraties
        <v-btn v-if="this.registrations.length > 0" @click="sendAllRegistrations" depressed small outlined color="secondary">Alles opslaan in cloud</v-btn>
      </h2>

      <v-data-table
          :headers="headers"
          :items="this.registrations"
          mobile-breakpoint="0"
          sort-by="registration_updated_at"
          :sort-desc="[true]"
          :options.sync="options"
          :footer-props="{'items-per-page-options': [10, 25, 50, 100, -1]}"
          v-if="this.registrations.length"
      >
        <template #item.form_name="{ item }">
        <span :class="{ 'text-decoration-line-through': item.registration_saved_deleted_at }">
          {{ item.form_name }}
        </span>
        </template>
        <template #item.form_summary="{ item }">
          <div
              class="form-summary"
              v-if="item.form_summary"
              v-html="replaceTokens(item.form_summary, getTokensFromSchema(item.schema), item.values, true, item.schema)"
          ></div>
        </template>
        <template #item.registration_updated_at="{ item }">
          {{ item.registration_updated_at|formatDate }}
        </template>
        <template #item.outbox="{ item }">
          <template v-if="item.outbox">
            <v-chip small class="ma-1">
              {{ item.outbox.retries }}
            </v-chip>
            {{ item.outbox.last_error }}
          </template>
        </template>
        <template #item.actions="{ item }">
          <!--        <v-btn outlined small color="secondary" v-if="hasConflict(item.fill_token)" @click.stop="openConflictModal(item)"><v-icon>mdi-source-branch</v-icon>Kies versie</v-btn>-->
          <!--        <v-btn outlined small color="error" v-if="!item.registration_saved_deleted_at || !item.fill_token" @click.stop="deleteRegistrationConfirm(item)"><v-icon>mdi-trash-can</v-icon>Verwijder</v-btn>-->

          <v-btn outlined small color="primary" @click="stopSendingRegistration(item)" v-if="isSendingRegistration(item)" class="mr-2">Stop opslaan</v-btn>
          <v-btn outlined small color="secondary" @click="sendRegistration(item)" v-if="!isSendingRegistration(item)">Opslaan in cloud</v-btn>

          <v-btn outlined small color="error" @click="deleteRegistration(item)" v-if="!isSendingRegistration(item)" class="ml-2">Verwijder</v-btn>

          <v-progress-circular v-if="isSendingRegistration(item)" indeterminate class="mr-2"></v-progress-circular>

        </template>
      </v-data-table>

      <p v-if="this.registrations.length === 0">
        U heeft momenteel geen lokaal opgeslagen registraties.
      </p>

    </v-sheet>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import eformHelpers from "@/mixins/eformHelpers";

export default {
  name: "RegistrationOutboxList",
  mixins: [
    eformHelpers
  ],
  data () {
    return {
      options: {
        itemsPerPage: -1
      },
      headers: [
        {
          text: 'Formulier naam',
          sortable: true,
          align: 'start',
          value: 'form_name',
        },
        {
          text: 'Samenvatting',
          sortable: true,
          align: 'start',
          value: 'form_summary',
        },
        {
          text: 'Laatste wijziging',
          sortable: true,
          align: 'start',
          value: 'registration_updated_at',
        },
        {
          text: 'Pogingen',
          sortable: true,
          align: 'start',
          value: 'outbox',
        },
        {
          text: 'Acties',
          value: 'actions',
          width: '350px',
        },
      ],
    }
  },
  computed: {
    ...mapGetters(["appOnline"]),
    registrations() {
      return this.$store.getters['registrationOutbox/getRegistrations'] || [];
    }
  },
  async mounted() {

  },
  methods: {
    async sendRegistration(item) {
      let response = await this.$store.dispatch('registrationOutbox/sendRegistrationToServer', {registrationId: item.outbox.id, timeout: 120000} ); // When sending manually, we give it a longer timeout.
      if (response.status === true) {
        this.$toast.success(response.message)
        this.$emit('registration-sent');
        return;
      }
      this.$toast.error(response.message)
    },
    isSendingRegistration(item) {
      return item.outbox.processing === true;
    },
    stopSendingRegistration(item) {
      this.$store.dispatch('registrationOutbox/unmarkProcessing', {registrationId: item.outbox.id});
    },
    async sendAllRegistrations() {
      await this.$store.dispatch('registrationOutbox/syncRegistrationsToServer', {numberOfItems: 0} );
      this.$emit('registration-sent');
    },
    async deleteRegistration(item) {
      if (confirm('Weet u zeker dat u deze registratie wilt verwijderen? Dit kan niet ongedaan worden gemaakt.')) {
        await this.$store.dispatch('registrationOutbox/delete', {registrationId: item.outbox.id});
      }
    },
  },
}
</script>

<style scoped>

</style>